// components/SidebarNav.js
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaChevronDown, FaDashcube, FaMoneyBill, FaChartLine, FaProjectDiagram, FaWallet, FaUniversity, FaExchangeAlt, FaUserPlus, FaUsers, FaSignOutAlt } from 'react-icons/fa';
import logo from '../logo2.png';
import { AuthContext } from './AuthContext';
import '../index.css';

const SidebarNav = () => {
    const { userRole, logout } = useContext(AuthContext);
    const [isOperationOpen, setIsOperationOpen] = useState(true);
    const [isDataMaintenanceOpen, setIsDataMaintenanceOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true); // 控制侧边栏的显示状态
    const navigate = useNavigate();

    const handleLogout = () => {
        logout(); // 调用 AuthContext 中的登出函数
        navigate('/'); // 跳转到登录页面
    };

    return (
        <>
            {/* 汉堡菜单图标 */}
            <div className="fixed top-5 left-5 text-2xl text-blue-600 z-50 cursor-pointer" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                <FaBars />
            </div>

            <nav className={`fixed top-0 left-0 h-full bg-white dark:bg-gray-800 shadow-lg border-r transition-transform duration-300 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} w-64`}>
                {/* 侧边栏内容 */}
                <div className="p-5">
                    <img src={logo} alt="Kindbridge Investments" className="w-3/4 mx-auto mb-6" />
                    <ul className="space-y-4">
                        <li>
                            <Link to="/dashboard" className="flex items-center p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition">
                                <FaDashcube className="text-lg text-blue-600 mr-3" /> 主页
                            </Link>
                        </li>
                        <li>
                            <div className="flex items-center p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition cursor-pointer" onClick={() => setIsOperationOpen(!isOperationOpen)}>
                                <FaChevronDown className={`text-lg text-blue-600 mr-3 transform ${isOperationOpen ? 'rotate-180' : ''}`} /> 业务功能
                            </div>
                            {isOperationOpen && (
                                <ul className="pl-6 mt-2 space-y-2">
                                    <li><Link to="/payroll" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaMoneyBill className="text-blue-600 mr-3" /> 工资支付</Link></li>
                                    <li><Link to="/generate-report" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaChartLine className="text-blue-600 mr-3" /> 财务报表</Link></li>
                                    <li><Link to="/project-expense" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaProjectDiagram className="text-blue-600 mr-3" /> 记录支出</Link></li>
                                    <li><Link to="/record-income" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaWallet className="text-blue-600 mr-3" /> 记录收入</Link></li>
                                </ul>
                            )}
                        </li>
                        {userRole === 'admin' && (
                            <li>
                                <div className="flex items-center p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition cursor-pointer" onClick={() => setIsDataMaintenanceOpen(!isDataMaintenanceOpen)}>
                                    <FaChevronDown className={`text-lg text-blue-600 mr-3 transform ${isDataMaintenanceOpen ? 'rotate-180' : ''}`} /> 公司数据维护
                                </div>
                                {isDataMaintenanceOpen && (
                                    <ul className="pl-6 mt-2 space-y-2">
                                        <li><Link to="/add-bank-account" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaUniversity className="text-blue-600 mr-3" /> 添加银行账户</Link></li>
                                        <li><Link to="/manage-transactions" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaExchangeAlt className="text-blue-600 mr-3" /> 管理交易</Link></li>
                                        <li><Link to="/add-employee" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaUserPlus className="text-blue-600 mr-3" /> 添加员工</Link></li>
                                        <li><Link to="/employee-management" className="flex items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"><FaUsers className="text-blue-600 mr-3" /> 员工管理</Link></li>
                                    </ul>
                                )}
                            </li>
                        )}
                        {/* 退出登录按钮 */}
                        <li className="mt-4">
                            <button onClick={handleLogout} className="flex items-center w-full text-left p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition">
                                <FaSignOutAlt className="text-lg text-red-600 mr-3" /> 退出登录
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default SidebarNav;